module.exports = __webpack_public_path__ + "static/media/portrait.e91bdfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/portrait.png
// module id = 637
// module chunks = 0